/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";


function Tag({ value, classes }) {
  return (
    <span className="inline-block px-1" key={value}>
    <span
        className={`inline-flex items-center px-3 py-1 text-xs  font-medium leading-tight ${classes} rounded-full my-1`}>{value}</span>
    </span>

  );
}

export default Tag;